import {themeGetter} from 'quickstart/system'

const getDigests = (theme: any) => {
  const th = themeGetter(theme)
  return {
    default: {
      digest: {
        backgroundColor: th('colors.backgroundColorWhite'),
      },
      heading: {
        ...th('fonts.heading'),
        ...th('prose.digestHeadLg'),
      },
      snippet: {
        ...th('fonts.body'),
        ...th('ui.digestSnippetLg'),
      },
    },
    small: {
      heading: {
        ...th('prose.digestHeadSm'),
      },
      snippet: {
        ...th('ui.digestSnippetSm'),
      },
    },
    medium: {
      heading: {
        ...th('prose.digestHeadMd'),
      },
      snippet: {
        ...th('ui.digestSnippetMd'),
      },
    },
  }
}

export default getDigests
